import type { OlProps } from "@components/OlProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getApplicationToFastestBenefits(tenant: Tenant): OlProps[] {
	return [
		{
			title: "Vývoj na moderních technologiích",
			desc: "Pracujeme s nejnovějšími technologiemi a sledujeme trendy v oboru.",
		},
		{ title: "Osobní ohodnocení", desc: "Oceňujeme kvalitní práci a férově odměňujeme podle výsledků." },
		{ title: "Přátelský kolektiv", desc: "Vytváříme otevřené a přátelské prostředí, kde se každý cítí dobře." },
		{ title: "Zajímavé projekty", desc: "Podílíme se na inovativních projektech s reálným dopadem." },
	];
}
